<template>
    <div class="living-container">
        <div class="video-wrapper">
            <TcPlayer
                v-show="showTcPlayer"
                ref="tcplayer"
                :live-data="liveData"
                :widthHeigt="[100, 100]"
                @toggle="handleToggle"
            />
            <div v-if="!showTcPlayer" class="pending-img">
                <img :src="liveData.liveImgUrl">
            </div>
            <van-icon class="play-icon" v-if="showTcPlayer && show" name="play-circle-o" @click="play" />
        </div>
        <div class="content-wrapper">
            <div class="visit">
                <div class="liveType">
                    <span class="iconfont icon-zhibo"></span>
                    <span v-if="liveData.liveState === 1">{{ $t('share.pending') }}</span>
                    <span v-if="liveData.liveState === 2">{{ $t('share.live') }}</span>
                    <span v-if="liveData.liveState === 3">{{ $t('share.playback') }}</span>
                </div>
                <div>
                    <span v-if="liveData.liveState !== 1">{{liveData.liveState === 1 ? liveData.liveWantCount : liveData.liveWatchCount}}人</span>
                    <!-- 想看 -->
                    <!-- <span v-if="liveData.liveState === 1">{{ $t('share.interested') }}</span> -->
                    <span v-if="liveData.liveState === 2">{{ $t('share.looking') }}</span>
                    <span v-if="liveData.liveState === 3">{{ $t('share.seen') }}</span>
                </div>
            </div>
            <div class="living-title">{{liveData.liveName}}</div>
            <div class="time">开播时间：{{liveData.liveStartDate | formatDate(0)}}</div>
            <div class="profile">
                <div>直播简介：</div>
                <div class="profile-info" v-html="liveData.liveDesc"></div>
            </div>
        </div>
        <!-- <template>
            <div class="empty-container">
                <div class="empty-inner">
                    <div class="empty-content">
                        <img
                            class="empty-img"
                            src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/portal/empty.png"
                            alt="暂无内容"
                        >
                        <div class="text">暂无内容</div>
                    </div>
                </div>
            </div>
        </template> -->
        <OpenAppView v-if="!isMiniApp" openKey="LiveDetail"/>
    </div>
</template>

<script>
import TcPlayer from '@/components/tc-player.vue'
import OpenAppView from '@/components/openAppView'

export default {
    components: {
        TcPlayer,
        OpenAppView
    },
    data() {
        return {
            isExhibitor: true,
            liveId: '',
            languageType: 'cn',
            liveData: {},
            show: true,
            isMiniApp: false
        }
    },
    computed: {
        showTcPlayer() {
            // 2.直播  3.回放
            return this.liveData.liveState === 2 || (this.liveData.liveState === 3 && this.liveData.playBackUrl)
        },
        allView() {
            // scope 0全部可见，1仅客户池观众，2仅自己可见、3预登记客户可见、4私密直播
            // 这里仅区分是否所有人可见
            return this.liveData.scope === 0
        }
    },
    mounted () {
       this.initParams() 
       this.getLiveDetail()
    },
    methods: {
        initParams() {
            const { showType, liveId, languageType, token } = this.$route.query
            if (token) {
                this.$store.commit('changeToken', token)
            }

            this.isExhibitor = showType === 'ACTOR'
            this.liveId = liveId
            this.languageType = languageType || 'cn'
            this.$i18n.locale = this.languageType
        },
        async getLiveDetail() {
            let params = {
                languageType: this.languageType,
                liveId: this.liveId // 1455直播 980回放
            }
            const res = await this.$http.liveDetail(params).catch(error => {
                console.log(error)
            })
            if (res.code === 1000) {
                const data = res.data
                this.liveData = data

                if (!this.allView) {
                    this.showDialog('请前往金融展App观看直播')
                }
                
                if (data.liveState === 3 && !this.liveData.playBackUrl) {
                    this.showDialog('暂无回放，请稍后重试')
                }

                // 直播微信分享
                if (this.$utils.isWeiXin()) {
                    const { liveName, liveDesc, shareImgUrl } = this.liveData
                    const config = {
                        title: liveName,
                        desc: liveDesc,
                        imgUrl: shareImgUrl
                    }
                    this.$utils.wxShareConfig(config)
                    this.$utils.isInMiniprogram().then(res => {
                        this.isMiniApp = res
                    })
                }
            }
        },
        play() {
            if (!this.allView) {
                return this.showDialog()
            }
            const tcplayer = this.$refs.tcplayer
            tcplayer && tcplayer.player.play()
            this.show = false
        },
        handleToggle(status) {
            // console.log(status)
            this.show = status
        },
        showDialog(message) {
            this.$dialog.alert({
                title: '提示',
                message
            })
        },
        isWeiXinFn() {
            const ua = navigator.userAgent.toLowerCase()
            const isWXWork = ua.match(/wxwork/i) == 'wxwork'
            const isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger'
            return isWeixin
        }
    }
}
</script>

<style lang="scss" scoped>
.living-container {
    max-width: 1000px;
    margin: 0 auto;
    .video-wrapper {
        width: 100%;
        /* min-height: 200px; */
        box-sizing: border-box;
        position: relative;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .pending-img {
            width: 100%;
            /* height: 200px; */
            img {
                width: 100%;
                height: 100%;
            }
        }
        .play-icon {
            width: 20px;
            height: 20px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate3d(-50%, -50%, 0);
            font-size: 38px;
            color: #ffffff;
        }
    }
    .content-wrapper {
        padding: 15px;
        .living-title {
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-top: 14px;
        }
        .visit {
            display: flex;
            justify-content: space-between;
            text-align: right;
            color: rgb(131, 128, 125);
            font-size: 14px;
            margin-top: 6px;
            .liveType {
                padding: 3px 10px;
                color: #ffffff;
                border-radius: 4px;
                font-size: 12px;
                background: #e50038;
                line-height: 16px;
                display: flex;
                align-items: center;
                .iconfont {
                    margin-right: 4px;
                }
            }
        }
        .time {
            margin-top: 6px;
        }
        .profile {
            margin-top: 6px;
            pre {
                margin: 0;
                padding: 0;
            }
            .profile-info {
                font-size: 14px;
                color: #333333;
                white-space: pre-wrap;
                margin-top: 2px;
            }
        }
    }
    .empty-container {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 101px;
        .empty-inner {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .empty-content {
                display: inline-block;
                .empty-img {
                    width: 100px;
                    height: 100px;
                }
                .text {
                    font-size: 12px;
                    text-align: center;
                    margin-top: 10px;
                    color: #333333;
                }
            }
            
        }
    }
    
}
</style>
